import React, { FC, PropsWithChildren, ReactElement } from 'react'
import cn from 'classnames'
import styles from './Chip.module.scss'
import { Icon } from '@/icons'

type ChipVariant = 'default' | 'ghost' | 'activated'

type ChipSize = 'big' | 'small'

interface ChipProps {
  className?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  title: string | ReactElement
  isDeletable?: boolean
  variant?: ChipVariant
  size?: ChipSize
}
export const Chip: FC<ChipProps> = ({
  className,
  title,
  isDeletable = false,
  variant = 'default',
  size = 'small',
  onClick,
}) => {
  return (
    <Wrapper
      className={className}
      onClick={onClick}
      variant={variant}
      size={size}
    >
      <span className={styles.content}>{title}</span>
      {isDeletable ? <Icon name="x" className={styles.iconClose} /> : null}
    </Wrapper>
  )
}

type WrapperProps = {
  className?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  variant: ChipVariant
  size: ChipSize
}
const Wrapper: FC<PropsWithChildren<WrapperProps>> = ({
  onClick,
  className,
  variant,
  size,
  children,
}) => {
  if (onClick != null) {
    return (
      <button
        type="button"
        className={cn(
          className,
          styles.container,
          styles[variant],
          styles[size]
        )}
        onClick={onClick}
      >
        {children}
      </button>
    )
  } else {
    return (
      <div
        className={cn(
          className,
          styles.container,
          styles[variant],
          styles[size]
        )}
      >
        {children}
      </div>
    )
  }
}
